import type {
  CatalogCategoryId,
  CatalogEntry,
  ExternalCatalogEntry,
  FirstPartyCatalogEntry,
} from "../contracts/catalog";
import type { GameManifest } from "../contracts/game";
import type { ExternalGameLink } from "./rosebud-catalog";
import rosebudCategoryAssignments from "../../scripts/rosebud-category-assignments.json" with { type: "json" };

/** Generated by scripts/catalog-categories.mts; trusted shape, not user input. */
const ROSEBUD_CATEGORIES = rosebudCategoryAssignments as Readonly<Record<string, readonly CatalogCategoryId[]>>;

export const CATALOG_BASELINE_TIMESTAMP = 1_735_689_600_000; // 2025-01-01T00:00:00Z

/** Hand-assigned to mirror LOCAL_GAME_MANIFESTS by stable id. */
const FIRST_PARTY_CATEGORIES: Readonly<Record<string, readonly CatalogCategoryId[]>> = {
  "momentum-track": ["racing"],
  marbles: ["puzzle"],
  "tic-tac-whoa": ["cards-board"],
  "sausage-simulator": ["creative"],
  "2048": ["puzzle"],
  "carcade-city": ["building"],
  "a-dark-room": ["adventure"],
  freeciv: ["building", "cards-board"],
  "sector-trader": ["adventure"],
};

type FirstPartySource = Pick<GameManifest, "id" | "title" | "status" | "coverAsset" | "offline">;

export function firstPartyCatalogEntries(
  manifests: readonly FirstPartySource[],
  asOf: number,
): readonly FirstPartyCatalogEntry[] {
  return manifests.map((manifest) => ({
    kind: "first-party",
    catalogId: manifest.id,
    groupId: manifest.id,
    source: "carcade",
    sourceItemId: manifest.id,
    title: manifest.title,
    description: null,
    cover: { status: "present", url: manifest.coverAsset },
    categories: FIRST_PARTY_CATEGORIES[manifest.id] ?? ["other"],
    players: { status: "unknown" },
    inputs: ["touch"],
    offline: manifest.offline ?? "capable",
    status: manifest.status === "hidden" ? "hidden" : "active",
    launch: { gameId: manifest.id },
    receiptRef: "src/app/local-games.ts",
    createdAt: asOf,
    updatedAt: asOf,
  }));
}

export function externalCatalogEntries(
  links: readonly ExternalGameLink[],
  asOf: number,
): readonly ExternalCatalogEntry[] {
  return links.map((link) => ({
    kind: "external",
    catalogId: `rosebud:${link.slug}`,
    groupId: `rosebud:${link.slug}`,
    source: "rosebud",
    sourceItemId: link.slug,
    title: link.title,
    description: null,
    cover: { status: "present", url: link.coverUrl },
    categories: ROSEBUD_CATEGORIES[link.slug] ?? ["other"],
    players: { status: "unknown" },
    inputs: ["touch"],
    offline: "online-only",
    status: "active",
    launch: { url: link.url, slug: link.slug, ...(link.gatewayUrl ? { gatewayUrl: link.gatewayUrl } : {}) },
    receiptRef: "wiki/product/rosebud-catalog.md",
    createdAt: asOf,
    updatedAt: asOf,
  }));
}

export function catalogEntriesByCategory(
  entries: readonly CatalogEntry[],
  category: CatalogCategoryId,
): readonly CatalogEntry[] {
  return entries.filter((entry) => entry.categories.includes(category) && entry.status === "active");
}
